module.exports = __webpack_public_path__ + "static/media/americanflag.8e5d89d8.jpg";